<template>
  <v-layout class="summary-pane">
    <v-flex xs12>
      <div class="summary-section">
        <SummaryCompany />
      </div>

      <template v-if="hasTime">
        <div class="summary-section">
          <SummaryInspector />
        </div>

        <div class="summary-section">
          <SummarySchedule :displayAction="displayScheduleAction" />
        </div>
      </template>

      <div v-if="showEstimate" class="summary-section">
        <SummaryEstimate default-collapsed is-collapsible :displayAction="displayServicesAction" />
      </div>

      <template v-if="hasLocation">
        <div class="summary-section">
          <SummaryLocation :displayAction="displayPropertyAction" />
        </div>

        <div v-if="propertyDetailsIsEnabled" class="summary-section">
          <SummaryLocationDetails
            :displayAction="displayPropertyAction"
            default-collapsed
            is-collapsible />
        </div>
      </template>

      <div v-if="currentPerson" class="summary-section">
        <SummaryContact :displayAction="displayContactsAction" />
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import SummaryCompany from '@/components/SummaryCompany.vue';
import SummaryContact from '@/components/SummaryContact.vue';
import SummaryEstimate from '@/components/SummaryEstimate.vue';
import SummaryInspector from '@/components/SummaryInspector.vue';
import SummaryLocation from '@/components/SummaryLocation.vue';
import SummaryLocationDetails from '@/components/SummaryLocationDetails.vue';
import SummarySchedule from '@/components/SummarySchedule.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';
import FeatureFlagUtil from '@/utilities/feature-flag-util';

export default {
  components: {
    SummaryCompany,
    SummaryContact,
    SummaryEstimate,
    SummaryInspector,
    SummaryLocation,
    SummaryLocationDetails,
    SummarySchedule,
  },
  computed: {
    ...mapGetters('Appointment', [
      'hasEstimate',
      'hasLocation',
      'hasTime',
    ]),
    ...mapGetters('Company', ['propertyDetailsIsEnabled']),
    ...mapState({
      stepIndex: state => state.stepIndex,
    }),
    ...mapState('Auth', {
      currentPerson: state => state.person,
    }),
    displayScheduleAction() {
      return this.stepIndex > StepUtilities
        .getStepIndexByRouteName(RouteNameConstants.AppointmentSchedule);
    },
    displayServicesAction() {
      return this.stepIndex > StepUtilities
        .getStepIndexByRouteName(RouteNameConstants.AppointmentServices);
    },
    displayPropertyAction() {
      return this.stepIndex > StepUtilities
        .getStepIndexByRouteName(RouteNameConstants.AppointmentProperty);
    },
    displayContactsAction() {
      return this.stepIndex > StepUtilities
        .getStepIndexByRouteName(RouteNameConstants.AppointmentContact);
    },
    showEstimate() {
      return !!(this.hasEstimate && FeatureFlagUtil.isServicesEnabled());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';

.summary-pane {
  ::v-deep .formatted-address {
    font-size: 1rem;
    color: lighten($typography-color-body, 8.63);
    line-height: 1.71;

    &--street {
      color: $typography-color-body;
      font-size: 1.15rem;
      font-weight: $typography-weight-bold;
    }
  }

  ::v-deep .summary--title {
    margin-bottom: 0.8rem;
  }

  ::v-deep .summary--row {
    padding: 0.6rem 0;
  }
}

.summary-section {
  padding: 1.8rem 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
}

::v-deep .summarylocation--meta {
  padding: 5px 0;
}
</style>
